import styled from '@emotion/styled';
import images from 'src/assets/image';
import { media } from 'src/theme/breakpoints';
import { typography } from 'src/theme/typography';

const LoginStyle = styled('div')`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-image: url(${images.loginBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: fixed;
    .viewLogin {
        display: flex;
        width: 420px;
        max-width: calc(100% - 32px);
        min-height: 560px;
        padding: 40px;
        border-radius: 6px;
        background-color: var(--burgundy-800);
        background-image: url(${images.loginCardPattern});
        background-size: cover;
        background-position: center;
    }
    .groupsItemLogin {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .LogoIMG {
        width: 250px;
        max-width: 100%;
        margin-top: 40px;
    }
    .titleLogin {
        ${typography.headingXl}
        margin: 124px 0 105px;
        text-align: center;
        color: var(--sand-100);
    }
    .viewFromInput {
        width: 100%;
    }
    .custom-btuton {
        ${typography.buttonLg}
        width: 100%;
        height: 48px;
        border-radius: 8px;
        background-color: var(--orange-300);
        color: var(--sand-100);
    }
    .custom-btuton:hover {
        background-color: var(--orange-400) !important;
    }
    ${media.mobile} {
        .viewLogin {
            min-height: auto;
            padding: 24px;
        }
        .LogoIMG {
            width: 200px;
            margin-top: 8px;
        }
        .titleLogin {
            margin: 48px 0;
        }
    }
`;
export default LoginStyle;
